import React from 'react';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const formatValue = value => {
    if (value === undefined || value === null || value === '') return 'Не указано';

    if (typeof value === 'object') {
        return value.name || value.label || value.id || value._id || JSON.stringify(value);
    }

    return String(value);
};

const RenderListItems = ({ items = [] }) => {
    if (!items.length) {
        return (
            <div className="applicationChangeProfile__legacyNotice">
                Для этой старой записи нет структурированного массива изменений.
            </div>
        );
    }

    return (
        <div className="applicationChangeProfile__changesList">
            <div className="applicationChangeProfile__listItemRowTitle">
                <div>Поле</div>
                <div>Было</div>
                <div />
                <div>Стало</div>
            </div>

            {items.map((item, index) => (
                <div
                    className="applicationChangeProfile__listItemRow"
                    key={`${item.field || item.nameSubmit || 'field'}-${index}`}
                >
                    <div className="applicationChangeProfile__name">
                        {item.label || item.name || item.field || 'Поле'}
                    </div>

                    <div className="applicationChangeProfile__before">
                        {formatValue(item.before)}
                    </div>

                    <div className="applicationChangeProfile__arrow">
                        <ArrowForwardRoundedIcon />
                    </div>

                    <div className="applicationChangeProfile__after">
                        {formatValue(item.after)}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RenderListItems;
